import { render } from "./CardContextMenu.vue?vue&type=template&id=28e6dd7e&scoped=true&ts=true"
import script from "./CardContextMenu.vue?vue&type=script&lang=ts"
export * from "./CardContextMenu.vue?vue&type=script&lang=ts"

import "./CardContextMenu.vue?vue&type=style&index=0&id=28e6dd7e&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28e6dd7e"]])

export default __exports__